import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
// Styles
import {
   Container,
   Wrapper,
   Slide,
   Image,
   ImageFull,
   SlideBalls,
   SlideBall,
   Video,
   VideoFull,
} from "./ProductImages.styles"

const ProductImages = ({ images }) => {
   const [slideIndex, setSlideIndex] = useState(0)
   const [display, setDisplay] = useState("none")
   const [touchPosition, setTouchPosition] = useState(null)

   const nextSlide = () => {
      setSlideIndex(
         slideIndex < images.length - 1 ? slideIndex + 1 : slideIndex
      )
   }
   const prevSlide = () => {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : slideIndex)
   }

   const handleTouchStart = (e) => {
      const touchDown =
         e._reactName === "onMouseDown" ? e.clientX : e.touches[0].clientX
      setTouchPosition(touchDown)
   }

   const handleTouchMove = (e) => {
      const touchDown = touchPosition
      if (touchDown === null) {
         return
      }
      const currentTouch =
         e._reactName === "onMouseUp" ? e.clientX : e.touches[0].clientX
      const diff = touchDown - currentTouch
      if (diff > 5) {
         nextSlide()
      } else if (diff < -5) {
         prevSlide()
      }
      setTouchPosition(null)
   }

   useEffect(() => {
      if (images.length < slideIndex + 1) {
         setSlideIndex(0)
      }
   }, [images, slideIndex])

   return (
      <>
         <Container>
            <Wrapper
               slideIndex={slideIndex}
               onDoubleClick={() => setDisplay("flex")}
               onTouchStart={handleTouchStart}
               onTouchMove={handleTouchMove}
               onMouseDown={handleTouchStart}
               onMouseUp={handleTouchMove}
            >
               {images.map((item, index) => (
                  <Slide key={index}>
                     {item.includes("_v") ? (
                        <Video
                           loop
                           autoPlay
                           muted
                           key={index}
                           src={item}
                           type="video/mp4"
                        />
                     ) : (
                        <Image key={index} src={item} draggable={false} />
                     )}
                  </Slide>
               ))}
            </Wrapper>
            <SlideBalls>
               {images.map((item, index) => (
                  <SlideBall
                     key={index + "-" + item}
                     onClick={() => setSlideIndex(index)}
                     bgColor={slideIndex === index ? "secondary" : "primary"}
                  />
               ))}
            </SlideBalls>
         </Container>
         {images[slideIndex]?.includes("_v") ? (
            <VideoFull
               loop
               autoPlay
               muted
               display={display}
               src={images[slideIndex]}
               onClick={() => setDisplay("none")}
            />
         ) : (
            <ImageFull
               display={display}
               src={images[slideIndex]}
               onClick={() => setDisplay("none")}
            />
         )}
      </>
   )
}

ProductImages.propTypes = {
   images: PropTypes.array,
}

export default ProductImages
